import { render, staticRenderFns } from "./SchedulingSettings.vue?vue&type=template&id=7c352875&scoped=true&"
import script from "./SchedulingSettings.vue?vue&type=script&lang=ts&"
export * from "./SchedulingSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SchedulingSettings.vue?vue&type=style&index=0&id=7c352875&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c352875",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
